var FcDeadlineViolationReasonInputModule = /** @class */ (function () {
    function FcDeadlineViolationReasonInputModule() {
    }
    return FcDeadlineViolationReasonInputModule;
}());
export { FcDeadlineViolationReasonInputModule };
